<!-- component that shows pet details on right bar -->
<template>
  <div class="p2">
    <dl class="px1 m0 h5">
      <dt>Nimi vakuutustiedoissa</dt>
      <dd>{{chat.pet.name}}</dd>

      <dt>Eläinlaji / rotu</dt>
      <dd>{{species}} / {{chat.pet.breed}}</dd>

      <dt>Sukupuoli</dt>
      <dd v-if="chat.pet.gender">{{gender}}</dd>
      <dd v-else>Asiakas ei antanut sukupuolta</dd>

      <dt>Syntymäaika</dt>
      <dd>{{getPetBirthDay()}}</dd>

      <dt>Paino</dt>
      <dd v-if="chat.pet.weight">{{chat.pet.weight}} kg</dd>
      <dd v-else>Asiakas ei antanut painoa</dd>

      <dt v-if="chat.pet.details">Lisätietoja lemmikistä</dt>
      <dd v-if="chat.pet.details">{{chat.pet.details}}</dd>

      <dt>Oirekartoitus:</dt>

      <template v-for="qa in chat.userQuestionnaire">
        <dt>{{qa.question}}</dt>
        <dd style="white-space: pre-wrap;">{{qa.answer}}</dd>
      </template>
    </dl>
  </div>
</template>

<script>
import Util from '@/util';

export default {
    name: 'PetDetails',
    props: {
      chat: Object,
    },
    computed: {
      species() {
        return Util.mapSpecies(this.chat.pet.species);
      },
      gender() {
        return Util.mapGender(this.chat.pet);
      },
    },
    methods: {
      getPetBirthDay: function() {
        if (!this.chat.pet.birthdate) {
          return "Asiakas ei antanut syntymäaikaa";
        }
        const birthDay = new Date(this.chat.pet.birthdate);
        const day = (birthDay.getDate() >= 10) ? birthDay.getDate() : '0' + birthDay.getDate()
        const month = (birthDay.getMonth() >= 9) ? (birthDay.getMonth()+1) : '0' + (birthDay.getMonth()+1)
        return day + '.' + month + '.' + birthDay.getFullYear();
      }
    }
};
</script>


<style scoped>
</style>
